import * as TK from 'components/post/PostFormMedia/translations/constants';
import { Translations } from 'translations/types';

export const postFormMediaEnUsLocale: Translations = {
  [TK.POST_FORM_MEDIA_TITLE]: 'Photos/Videos',
};
